import { Component, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuItem, RichDataModel } from 'src/app/models/rich-data.model';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [TranslatePipe]
})
export class SearchComponent implements OnInit {

  richMobileData: any;
  menuItems: MenuItem[];
  searchQuery = '';

  constructor(public dataServ: DataService
  ) { }

  async ngOnInit() {
    this.richMobileData = await this.dataServ.getMobileGzip();
    this.menuItems = this.richMobileData.menu_items;    
  }
}
